import React, { useState, useEffect } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import BackToTop from "../../components/backToTop/BackToTop";
import "./../privacyPolicy/PrivacyPolicy.css"; // reuse same styling

const TermsOfUse = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    useEffect(() => {
      const filters = document.querySelector(".filters-row");
  
      const handleScroll = () => {
        if (!filters) return;
  
        const offset = filters.getBoundingClientRect().top;
  
        if (offset <= 80) {
          filters.classList.add("stuck");
        } else {
          filters.classList.remove("stuck");
        }
      };
  
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);
  
    useEffect(() => {
      // Scroll to top smoothly when the component mounts / route changes
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant", // or "smooth" if you prefer a gentle scroll
      });
    }, []);  


  const handleSectionClick = () => {
    setIsSidebarOpen(false);
  };

  return (
    <>
      <Header
        isMenuOpen={isMenuOpen}
        onMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
      />

      {/* ===== HERO ===== */}
      <section className="legal-hero">
        <div className="legal-container">
          <h1>TUTORSLINKS Terms of Use</h1>
        </div>
      </section>

      {/* ===== CONTENT ===== */}
      <section className="legal-content-section">
        <div className="legal-container legal-grid">
          {/* ===== MOBILE SIDEBAR TOGGLE ===== */}
          <button
            className="sidebar-toggle"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            {isSidebarOpen ? "Close Sections" : "View Sections"}
          </button>

          {isSidebarOpen && (
            <div
              className="sidebar-overlay"
              onClick={() => setIsSidebarOpen(false)}
            />
          )}

          {/* ===== SIDEBAR ===== */}
          <aside className={`legal-sidebar ${isSidebarOpen ? "open" : ""}`}>
            <a href="#about" onClick={handleSectionClick}>About TutorsLinks</a>
            <a href="#eligibility" onClick={handleSectionClick}>Eligibility</a>
            <a href="#registration" onClick={handleSectionClick}>Account Registration</a>
            <a href="#roles" onClick={handleSectionClick}>User Roles</a>
            <a href="#platform-use" onClick={handleSectionClick}>Use of the Platform</a>
            <a href="#tutor-obligations" onClick={handleSectionClick}>Tutor Obligations</a>
            <a href="#student-responsibilities" onClick={handleSectionClick}>Student Responsibilities</a>
            <a href="#payments" onClick={handleSectionClick}>Payments & Fees</a>
            <a href="#intellectual-property" onClick={handleSectionClick}>Intellectual Property</a>
            <a href="#reviews" onClick={handleSectionClick}>Reviews & Feedback</a>
            <a href="#child-protection" onClick={handleSectionClick}>Child Protection</a>
            <a href="#disputes" onClick={handleSectionClick}>Dispute Resolution</a>
            <a href="#termination" onClick={handleSectionClick}>Suspension & Termination</a>
            <a href="#disclaimer" onClick={handleSectionClick}>Disclaimer</a>
            <a href="#limitation" onClick={handleSectionClick}>Limitation of Liability</a>
            <a href="#privacy" onClick={handleSectionClick}>Privacy</a>
            <a href="#amendments" onClick={handleSectionClick}>Amendments</a>
            <a href="#governing-law" onClick={handleSectionClick}>Governing Law</a>
            <a href="#contact" onClick={handleSectionClick}>Contact Information</a>
          </aside>

          {/* ===== MAIN CONTENT ===== */}
          <div className="legal-content">
            <p className="last-updated">Last Updated: 28 February, 2026</p>

            <p>
              Welcome to <strong>TutorsLinks</strong>, a service operated by
              <strong> Efiko Edutech Ltd.</strong> These Terms of Use (“Terms”)
              govern your access to and use of the TutorsLinks website, mobile
              application, and related services (collectively, the “Platform”).
              By accessing, registering on, or using TutorsLinks, you confirm
              that you have read, understood, and agreed to be bound by these
              Terms.
            </p>

            {/* 1 */}
            <section id="about">
              <h2>1. About TutorsLinks</h2>
              <p>
                TutorsLinks is an educational technology platform that connects:
              </p>
              <ul>
                <li>Students and learners</li>
                <li>Tutors, instructors, and training centres</li>
              </ul>
              <p>
                TutorsLinks acts{" "}
                <strong>only as a facilitator and intermediary</strong> and does
                not directly provide teaching services unless explicitly stated.
              </p>
            </section>

            {/* 2 */}
            <section id="eligibility">
              <h2>2. Eligibility</h2>
              <p>To use TutorsLinks:</p>
              <ul>
                <li>
                  You must be at least <strong>18 years old</strong>, or
                </li>
                <li>
                  If under 18, you must have{" "}
                  <strong>parental or guardian consent</strong>
                </li>
                <li>
                  You must provide{" "}
                  <strong>accurate and truthful information</strong> during
                  registration
                </li>
              </ul>
              <br />
              TutorsLinks reserves the right to deny access to any user who
              fails to meet these requirements.
            </section>

            {/* 3 */}
            <section id="registration">
              <h2>3. Account Registration & Security</h2>
              <ul>
                <li>
                  You are responsible for maintaining the confidentiality of
                  your login details.
                </li>
                <li>
                  You agree to notify TutorsLinks immediately of any
                  unauthorized access to your account.
                </li>
                <li>
                  You may not create multiple accounts for deceptive or
                  fraudulent purposes.{" "}
                </li>
                <li>
                  {" "}
                  TutorsLinks may suspend or terminate accounts found to contain
                  false or misleading information.
                </li>
              </ul>
            </section>

            {/* 4 */}
            <section id="roles">
              <h2>4. User Roles</h2>
              <p>Users on TutorsLinks may register as:</p>
              <ul>
                <li>
                  <strong>Students / Learners</strong>
                </li>
                <li>
                  <strong>Tutors</strong>
                </li>

                <li>
                  <strong>Training Centers</strong>
                </li>
              </ul>
              <p>
                Each role has specific responsibilities, obligations, and
                permissions on the Platform.
              </p>
            </section>

            {/* 5 */}
            <section id="platform-use">
              <h2>5. Use of the Platform</h2>
              <p>
                You agree to use TutorsLinks only for lawful educational
                purposes and not to:
              </p>
              <ul>
                <li>Engage in fraud, impersonation, or misrepresentation </li>
                <li>Harass, abuse, or exploit other users</li>
                <li>Share offensive, illegal, or harmful content </li>
                <li>
                  Circumvent TutorsLinks’ payment or communication systems
                </li>
                <li>Violate any applicable Nigerian or international laws </li>
              </ul>
            </section>

            {/* 6 */}
            <section id="tutor-obligations">
              <h2>6. Tutor & Training Centre Obligations</h2>
              <p>Tutors and centres agree to: </p>
              <ul>
                <li>
                  Provide accurate qualifications, credentials, and course
                  information{" "}
                </li>
                <li>Deliver services as described and scheduled </li>
                <li>
                  Comply with the <strong>Code of Conduct</strong> and{" "}
                  <strong>Child Protection and Safeguarding Policy</strong>
                </li>
                <li>Maintain professionalism and appropriate boundaries </li>
                <li>
                  Accept responsibility for the quality of services
                  delivered{" "}
                </li>
              </ul>
              <p>
                TutorsLinks does not guarantee student enrollment or income to
                tutors or centres.
              </p>
            </section>

            {/* 7 */}
            <section id="student-responsibilities">
              <h2>7. Student Responsibilities</h2>
              <p>Students agree to:</p>
              <ul>
                <li>Provide accurate personal information</li>
                <li>
                  Attend scheduled sessions or cancel within stated timelines
                </li>
                <li>Use the Platform respectfully and responsibly</li>
                <li>Make payments only through TutorsLinks</li>
                <li>Avoid bypassing the Platform for private arrangements </li>
              </ul>
            </section>

            {/* 8 */}
            <section id="payments">
              <h2>8. Payments & Fees</h2>
              <ul>
                <li>
                  All payments must be made through TutorsLinks’ approved
                  payment channels.
                </li>
                <li>
                  TutorsLinks may charge{" "}
                  <strong>service or transaction fees</strong>, which will be
                  clearly disclosed.
                </li>
                <li>
                  Tutors receive payouts subject to verification of service
                  delivery.
                </li>
                <li>
                  Refunds and cancellations are governed by the{" "}
                  <strong>Refund & Cancellation Policy</strong>.
                </li>
              </ul>
            </section>

            {/* 9 */}
            <section id="intellectual-property">
              <h2>9. Content & Intellectual Property</h2>
              <ul>
                <li>
                  Tutors retain ownership of their original teaching materials.
                </li>
                <li>
                  By uploading content, you grant TutorsLinks a non-exclusive
                  license to display and promote such content on the Platform.
                </li>
                <li>
                  Users may not copy, distribute, or reuse content without
                  permission.
                </li>
                <li>
                  All TutorsLinks branding, logos, and platform materials remain
                  the property of Efiko Edutech Ltd.
                </li>
              </ul>
            </section>

            {/* 10 */}
            <section id="reviews">
              <h2>10. Reviews & Feedback</h2>
              <ul>
                <li>Students may leave honest and constructive reviews.</li>
                <li>Reviews must not be false, abusive, or defamatory. </li>
                <li>
                  TutorsLinks reserves the right to remove reviews that violate
                  these Terms.
                </li>
              </ul>
            </section>

            {/* 11 */}
            <section id="child-protection">
              <h2>11. Child Protection & Safeguarding</h2>
              <p>
                All users must comply with TutorsLinks’
                <strong>Child Protection and Safeguarding Policy</strong>.
                <br />
                Any violation involving minors may result in:
              </p>
              <ul>
                <li>Immediate account suspension or termination</li>
                <li>Reporting to relevant authorities </li>
              </ul>
            </section>

            {/* 12 */}
            <section id="disputes">
              <h2>12. Dispute Resolution</h2>
              <ul>
                <li>
                  Users are encouraged to resolve disputes amicably via platform
                  communication.
                </li>
                <li>
                  Unresolved issues may be escalated under the
                  <strong> Dispute Resolution & Complaints Procedure </strong>.
                </li>
                <li>
                  TutorsLinks’ final decision after investigation shall be
                  binding.
                </li>
              </ul>
            </section>

            {/* 13 */}
            <section id="termination">
              <h2>13. Suspension & Termination</h2>
              <p>
                TutorsLinks may suspend or terminate accounts without prior
                notice if a user:
              </p>
              <ul>
                <li>Violates these Terms or any related policy</li>
                <li>Engages in misconduct, fraud, or abuse </li>
                <li>Poses a risk to other users or the Platform</li>
              </ul>
              <br />
              Users may also request voluntary account deletion.
            </section>

            {/* 14 */}
            <section id="disclaimer">
              <h2>14. Disclaimer of Liability</h2>
              <ul>
                <li>
                  TutorsLinks does not guarantee learning outcomes, examination
                  success, or employment results.
                </li>
                <li>
                  TutorsLinks is not responsible for actions, omissions, or
                  performance of tutors or students.
                </li>
                <li>In-person sessions are conducted at users’ own risk.</li>
              </ul>
              <p>
                To the maximum extent permitted by law, TutorsLinks disclaims
                liability for losses arising from platform use.
              </p>
            </section>

            {/* 15 */}
            <section id="limitation">
              <h2>15. Limitation of Liability</h2>
              <p>TutorsLinks shall not be liable for:</p>
              <ul>
                <li>Direct, indirect, incidental, or consequential damages</li>
                <li>Loss of data, income, or opportunities </li>
                <li> Disputes between users </li>
              </ul>
              <p>
                Total liability, if any, shall not exceed the fees paid to
                TutorsLinks within the preceding three (3) months.
              </p>
            </section>

            {/* 16 */}
            <section id="privacy">
              <h2>16. Privacy</h2>
              <p>
                All personal data is handled in accordance with the
                <strong>TutorsLinks Privacy Policy</strong> and applicable
                Nigerian data protection laws.
              </p>
            </section>

            {/* 17 */}
            <section id="amendments">
              <h2>17. Amendments</h2>
              <p>
                TutorsLinks may update these Terms from time to time. <br />
                Continued use of the Platform after updates constitutes
                acceptance of the revised Terms.
              </p>
            </section>

            {/* 18 */}
            <section id="governing-law">
              <h2>18. Governing Law</h2>
              <p>
                These Terms are governed by the laws of the{" "}
                <strong>Federal Republic of Nigeria</strong>.
              </p>
            </section>

            {/* 19 */}
            <section id="contact">
              <h2>19. Contact Information</h2>
              <p>For questions or concerns regarding these Terms:</p>
              <p>
                <strong>TutorsLinks (Efiko Edutech Ltd.)</strong>
                <br />
                Email: <strong>support@tutorslinks.com</strong>
              </p>
            </section>
          </div>
        </div>
      </section>
      {/* TRUST */}
      <section className="trust-section">
        <div className="trust-container">
          <div className="shield-icon">
            <img src="/images/shield-icon.png" alt="Trust" />
          </div>
          <h2>Your Trust Is Our Priority</h2>
          <p>
            Our Tutors are committed to the highest standard of student learning,
            safety, privacy and data protection. Verified tutors and training centres display a verification badge.
          </p>
          <a href="" className="trust-btn">
            Get Started →
          </a>
        </div>
      </section>

      <Footer />
      <BackToTop />
    </>
  );
};

export default TermsOfUse;
